import { render, staticRenderFns } from "./ConsultoriaFormAtualizar.vue?vue&type=template&id=28bbb071"
import script from "./ConsultoriaFormAtualizar.vue?vue&type=script&lang=js"
export * from "./ConsultoriaFormAtualizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports